import Vue from 'vue';
import { mapGetters } from 'vuex';
import { LevelName } from './types';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    name: 'YubikeyErrorPopupChunk',
    data: () => ({}),
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    methods: {
        hasntAccessHandler() {
            const hasCurrentMethod = this.getUserData.currentAccessRepairMethods.includes('yubikey');
            const vm = this;
            if (hasCurrentMethod) {
                this.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: true,
                    title: 'Предупреждение',
                    content: 'В данный момент идет восстановление Yubikey, установленного как метод 2FA для подтверждения операций в Личном кабинете. Вы сможете выполнить операцию после завершения восстановления.',
                    actions: [
                        {
                            title: 'Хорошо',
                            isAccent: true,
                            callback() { vm.$store.commit('popupModule/setClosed'); }
                        }
                    ]
                });
                return;
            }
            const isBasic = this.getUserData.verificationRights.levelName === LevelName.basic;
            if (isBasic) {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: false,
                    title: 'Восстановление Yubikey',
                    content: 'Чтобы восстановить Yubikey, нужно пройти расширенную верификацию аккаунта.',
                    actions: [
                        {
                            title: 'К разделу',
                            isAccent: true,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                                window.location.href = getPassportUrl('/id/', { withAcceptor: true });
                            }
                        },
                        {
                            title: 'Позже',
                            isAccent: false,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    ]
                });
                return;
            }
            this.$router.push({ name: 'AccessRepair', query: { secondFactor: 'yubikey', an3K8QkkJb3Mzz: this.slotData.sessionId } });
        }
    }
});
